'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _styledComponentsReactiveGrid = require('styled-components-reactive-grid');

var _decisivUiUtils = require('decisiv-ui-utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// this acts as our <thead> element
var styles = function styles(_ref) {
  var theme = _ref.theme;
  return '\n  background-color: ' + theme.colors.base.background + ';\n  border-bottom: solid 1px ' + theme.colors.base.chrome200 + ';\n  display: flex;\n  flex-wrap: nowrap;\n  flex: 1;\n  min-height: ' + (0, _decisivUiUtils.px2rem)(50) + ';\n  z-index: 1;\n';
};

var themePropTypes = {
  colors: _propTypes2.default.shape({
    base: _propTypes2.default.shape({
      background: _propTypes2.default.string.isRequired,
      chrome200: _propTypes2.default.string.isRequired
    }).isRequired
  }).isRequired
};

exports.default = (0, _decisivUiUtils.buildStyledComponent)('Head', (0, _styledComponents2.default)(_styledComponentsReactiveGrid.Row), styles, {
  themePropTypes: themePropTypes
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/base-components/build/blocks/ListTable/Head.js
// module id = 1597
// module chunks = 2